import { useTranslation } from 'react-i18next';
import { LoginError } from 'lavva.exalushome/build/js/Services/Session/ISessionService';
import { useBackdropContext } from '../../../../context/backdrop';
import { ROUTES } from '../../../../routes/routes';
import { toastError } from '../../../../utils/toast';
import { removeExalusCredentials } from '../../utils/installation';

export const useWrongAuthData = () => {
  const { t } = useTranslation('login');
  const { turnOffBackdrop } = useBackdropContext();

  const handleWrongAuthData = (loginError: LoginError, exalusCredentialsId: string) => {
    if (loginError === LoginError.WrongAuthData) {
      turnOffBackdrop();

      toastError({ content: t(`exalus.${LoginError[loginError as LoginError]}`) });
      removeExalusCredentials(exalusCredentialsId);
      window.location.href = ROUTES.Installation();
    }
  };

  return {
    handleWrongAuthData,
  };
};
